import {
  FieldAnswer,
  FieldOption,
  Patient,
  ReferenceCategory,
  referenceCategories,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId } from "@/src/utils/utils";

export async function getAntecedentsText({
  patient,
}: {
  patient: Patient | null | undefined;
}) {
  if (!patient) return "";
  let categoriesIds: ReferenceCategory[] = [
    "riskFactor",
    "personalAntecedent",
    "physiologicalAntecedent",
    "surgicalAntecedent",
    "familialAntecedent",
    "toxicAntecedent",
  ];

  let antecedents = await apiFetch(
    "refAnswers",
    "loadMany",
    {
      categories: categoriesIds,
      patientId: patient?.id || "",
    },
    "Erreur lors du chargement des antécédents"
  );

  let texts = [];
  for (let categoryId of categoriesIds) {
    let category = referenceCategories[categoryId];
    let categoryAntecedents = antecedents.filter(
      (antecedent) => antecedent.reference?.category == categoryId
    );
    if (!categoryAntecedents.length) continue;
    texts.push(`<strong>${category.pluralName}</strong>`);
    for (let antecedent of categoryAntecedents) {
      texts.push(
        `- ${antecedent?.reference?.name} ${getAnswersText(
          antecedent.fieldAnswers
        )} ${antecedent?.notes || ""} ${antecedent?.conclusion || ""}`
      );
    }
  }
  return texts.join("\n\n");
}

export async function getSimpleAntecedentsText({
  patient,
}: {
  patient: Patient | null | undefined;
}) {
  if (!patient) return "";
  let categoriesIds: ReferenceCategory[] = [
    "riskFactor",
    "personalAntecedent",
    "physiologicalAntecedent",
    "toxicAntecedent",
  ];

  let antecedents = await apiFetch(
    "refAnswers",
    "loadMany",
    {
      categories: categoriesIds,
      patientId: patient?.id || "",
    },
    "Erreur lors du chargement des antécédents"
  );

  let texts = [];
  for (let categoryId of categoriesIds) {
    let category = referenceCategories[categoryId];
    let categoryAntecedents = antecedents.filter(
      (antecedent) => antecedent.reference?.category == categoryId
    );
    if (!categoryAntecedents.length) continue;
    texts.push(`${category.pluralName}:`);
    for (let antecedent of categoryAntecedents) {
      console.log("antecedent", antecedent);
      texts.push(
        `- ${antecedent?.reference?.name} ${getAnswersText(
          antecedent.fieldAnswers
        )} ${antecedent?.notes || ""} ${antecedent?.conclusion || ""}`
      );
    }
  }
  return texts.join("\n\n");
}
export async function getSimpleFamilialAntecedentsText({
  patient,
}: {
  patient: Patient | null | undefined;
}) {
  if (!patient) return "";
  let categoriesIds: ReferenceCategory[] = ["familialAntecedent"];

  let antecedents = await apiFetch(
    "refAnswers",
    "loadMany",
    {
      categories: categoriesIds,
      patientId: patient?.id || "",
    },
    "Erreur lors du chargement des antécédents"
  );

  let texts = [];
  for (let categoryId of categoriesIds) {
    let category = referenceCategories[categoryId];
    let categoryAntecedents = antecedents.filter(
      (antecedent) => antecedent.reference?.category == categoryId
    );
    if (!categoryAntecedents.length) continue;
    texts.push(`${category.pluralName}:`);
    for (let antecedent of categoryAntecedents) {
      texts.push(
        `- ${antecedent?.reference?.name} ${getAnswersText(
          antecedent.fieldAnswers
        )} ${antecedent?.notes || ""} ${antecedent?.conclusion || ""}`
      );
    }
  }
  return texts.join("\n\n");
}

export function getAnswersText(
  fieldAnswers: (FieldAnswer | null | undefined)[] | null | undefined
) {
  if (!fieldAnswers) return "";
  return fieldAnswers
    ?.map((answer) => {
      if (!answer) return null;
      if (answer.field?.type == "upload") return null;
      if (answer.field?.type == "uploads") return null;
      let value = getAnswerValue(answer);
      if (!value) return null;
      return `${answer.field?.name}: ${value}`;
    })
    .filter((f) => f != null)
    .join(", \n");
}

export function getAnswerValue(answer: FieldAnswer | null): string | null {
  if (!answer) return null;
  let value = answer.value;
  let unit = answer?.field?.unit?.name;
  let optionsStr = getOptionsStr(answer?.field?.options || [], value);
  if (optionsStr) return optionsStr;
  if (!value) return null;
  if (Array.isArray(answer.value)) {
    return value
      ?.map((subValue: any) => subValue.name || subValue)
      .filter((f: any) => f != null)
      .join(", ");
  }
  if (typeof value == "object") return `${value.name || ""} ${unit || ""}`;
  return `${value || ""} ${unit || ""}`;
}

function getOptionsStr(options: (FieldOption | null | undefined)[], value: any) {
  if (!value) return "";
  if (value?.id) return value.name;
  let localValue = Array.isArray(value) ? value : [value];
  let names = [];
  for (let v of localValue) {
    let option = options.find(
      (o) => getItemId(o) == getItemId(v) || o?.name == v
    );
    if (option && option.name) names.push(option.name);
  }
  return names.join(", ");
}
